<!-- 查看图片详情 -->
<template>
  <a-modal v-model:visible="showModal" @cancel="handleCancel" centered width="616px" :footer="null">
    <template #title>
      <div class="modal_title">
        <span class="title">{{ title }}</span>
        <span class="tips">{{ tips }}</span>
      </div>
    </template>
    <!-- <div class="img_container" v-for="(it, index) in fileList" :key="index">
      <auth-img mode='ant' :width="140" :height="120" :src="it" />
    </div> -->
    <ImageWithName :fileList="fileList" :mode="5" />
  </a-modal>
</template>
<script setup>
import { defineProps, computed, defineEmits } from 'vue'
import ImageWithName from '@/components/ImageWithName'
const prop = defineProps({
  fileList: {
    type: Array,
    default: () => []
  },
  title: {
    type: String,
    default: ''
  },
  tips: {
    type: String,
    default: ''
  },
  visible: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['cancel'])
const showModal = computed(() => !!prop.visible)
const handleCancel = () => {
  emit('cancel')
}
</script>
<style scoped lang="scss">
.modal_title {
  display: flex;
  align-items: center;
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #000000d9;
  }
  .tips {
    margin-left: 10px;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
  }
}
// .img_container {
//   display: inline-block;
//   width: 140px;
//   height: 120px;
//   border-radius: 4px;
//   margin: 0 12px 12px 0;
//   overflow: hidden;
//   &:nth-child(3n) {
//     margin-right: 0;
//   }
//   ::v-deep(.ant-image) {
//     overflow: hidden;
//   }
// }
</style>
